import type http from 'http'

import type {
  TRouteParams,
  TRouteCallback,
  TServerCallback,
  TClientCallback
} from '../definitions'

interface ICallOptions {
  /** A callback. */
  callback: TRouteCallback

  /** A path. */
  path: string

  /** A paraméterk. */
  params: TRouteParams

  /** Ha szerveroldali, akkor a request. */
  req: http.IncomingMessage | undefined

  /** Ha szerveroldali, akkor a response. */
  res: http.ServerResponse | undefined
}

/**
 * Egy callback meghívása.
 * @param options - A.
 */
export default function callCallback (options: ICallOptions): Promise<void> {
  const { callback, params, path, req, res } = options

  if (req && res) {
    return (callback as TServerCallback)(params, req, res)
  }

  return (callback as TClientCallback)(params, '', path)
}
